import { Injectable } from '@angular/core';
import { AngularFireDatabase  } from 'angularfire2/database/database';
//import { DateTime } from 'ionic-angular';
//import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { AuthProvider } from '../providers/auth/auth';

@Injectable()
export class PartesService{
  constructor(public afDB: AngularFireDatabase,public auth : AuthProvider,){
    this.usuario =  this.getUsuario();
    this.getPersonal()
        .subscribe(personal => {
            this.personal = personal;
        });
  }

    usuario : number;
    personal = [];

   // parametros = {"idParte": 17216004};
    /*partes = [
        {"id": 17216003,
         "Poblacion": 'Riola'
         "Fecha": '2018-04-19',
         "Observaciones": 'Bajo peso de fruta.',
         "Unidades" : 391,
         "lineas": [      
          {"idParte": 17216003,
           "Vale": 111111,
           "Variedad": 'Navelina',
           "Unidades": 85},

           {"idParte": 17216003,
           "Vale": 222222,
           "Variedad": 'Navel',
           "Unidades": 105},

           {"idParte": 17216003,
           "Vale": 333333,
           "Variedad": 'Navel',
           "Unidades": 201},
          ],
          "personal": [
            {"id": 216001,
            "Nombre": 'RESHETILO, YEVGENIY',
            "Encargado": true,
            "Plus": 'Furgoneta',
            },
            {"id": 216002,
            "Nombre": 'BERNARD, PATRIK',
            "Encargado": false,
            "Plus": 'Coche',        
            },
            {"id": 216005,
            "Nombre": 'SEVELENKO, VALENTINAS',
            "Encargado": false,
            "Plus": '',      
            },
            ],
        },

        {"id": 17216002,
         "Poblacion": 'Algemesí',
         "Fecha": '2018-04-17',
         "Observaciones": 'Se puso a llover.',
         "Unidades" : 0,
         "lineas":[],
         "personal":[],
         },

        {"id": 17216001,
         "Poblacion": 'Gandía',
         "Fecha": '2018-04-14',
         "Observaciones": '',
         "Unidades" : 0,
         "lineas":[],
         "personal":[],
        },
    ];*/

    /*variedades = [
      {"id": '001',"Nombre":'Navel'},
      {"id": '002',"Nombre":'Navelina'},
      {"id": '003',"Nombre":'NewHall'},
      {"id": '004',"Nombre":'Navelate'},
      {"id": '005',"Nombre":'Lanelate'},
      {"id": '006',"Nombre":'Navel Powel'},
      {"id": '007',"Nombre":'Salustiana'},
      {"id": '008',"Nombre":'Valencia'},
      {"id": '009',"Nombre":'Sanguinelli'},
      {"id": '010',"Nombre":'Navel Chislett'},
      {"id": '011',"Nombre":'Loretina'},
      {"id": '012',"Nombre":'Marisol'},
      {"id": '013',"Nombre":'Clemenpons'},
      {"id": '014',"Nombre":'Oronules'},
      {"id": '015',"Nombre":'Arrufatina'},
      {"id": '016',"Nombre":'Mioro'},
      {"id": '017',"Nombre":'Esbal'},
      {"id": '018',"Nombre":'Oroval'},
      {"id": '019',"Nombre":'Orogrande'},
      {"id": '020',"Nombre":'Clemenules'},
      {"id": '021',"Nombre":'Clemenrubi'},
      {"id": '022',"Nombre":'Clemenvilla'},
      {"id": '023',"Nombre":'Hernandina'},
      {"id": '024',"Nombre":'Elendale'},
      {"id": '025',"Nombre":'Mineola'},
      {"id": '026',"Nombre":'Fortuna'},
      {"id": '027',"Nombre":'Ortanique'},
      {"id": '028',"Nombre":'Nadorcott'},
      {"id": '029',"Nombre":'Afourer'},
      {"id": '030',"Nombre":'Murcott'},
      {"id": '031',"Nombre":'Moncada'},
      {"id": '032',"Nombre":'Clemenfresh'},
      {"id": '033',"Nombre":'Beatriz'},
      {"id": '034',"Nombre":'Tango'},
      {"id": '035',"Nombre":'Bauzatina'},
      {"id": '036',"Nombre":'Prenules'},
      {"id": '037',"Nombre":'Orri'},
      {"id": '038',"Nombre":'Neufina'},
      {"id": '039',"Nombre":'Orogros'},
      {"id": '041',"Nombre":'Clausellina'},
      {"id": '042',"Nombre":'Satsuma'},
      {"id": '043',"Nombre":'Troyer'},
      {"id": '044',"Nombre":'Okitsu'},
      {"id": '045',"Nombre":'Iwasaki'},
      {"id": '046',"Nombre":'Primosole'},
      {"id": '047',"Nombre":'Owari'},
      {"id": '048',"Nombre":'Mor'},
      {"id": '051',"Nombre":'Primofiori'}
    ];*/

    /*personal = [
      {"id": 216001,
       "Nombre": 'RESHETILO, YEVGENIY',
       "Activo": true,
       "Encargado": true
       },
       {"id": 216002,
        "Nombre": 'BERNARD, PATRIK',
        "Activo": true,
        "Encargado": false
       },
       {"id": 216005,
        "Nombre": 'SEVELENKO, VALENTINAS',
        "Activo": false,
        "Encargado": false
       },
       {"id": 216006,
        "Nombre": 'BAUER, VITALI',
        "Activo": true,
        "Encargado": false
       },
       {"id": 216007,
        "Nombre": 'KUKUCZKA, JAN',
        "Activo": false,
        "Encargado": false
       }
    ];*/

      //Añadir,editar y eliminar Partes    

      public editParte(parte){
        this.afDB.database.ref('/cuadrillas/' + this.usuario + '/partes/' + parte.id).set(parte);
      } 

      public deleteParte(parte){
        this.afDB.database.ref('/cuadrillas/' + this.usuario + '/partes/' + parte.id).remove();
      }
      
      //Devuelve el numero de Unidades de las lineas de un Parte
      public countUnidades(parte){
        let Unidades = parseInt("0");
        for (let i = 0; i < parte.lineas.length; i++){
          Unidades = Unidades + parseInt(parte.lineas[i].Unidades);
        }
        return Unidades;
      }

      //Metodos get...
      public getPartesOrdenado(){
        return this.afDB.list('/cuadrillas/' + this.usuario + '/partes/',{query:{orderByChild: 'Orden'}});
      }
      public getPartes(){
        return this.afDB.list('/cuadrillas/' + this.usuario + '/partes/');
      }
      public refreshPersonal(){
        this.getPersonal()
        .subscribe(personal => {
            this.personal = personal;
        });
      }
      public getPersonal(){
        //return this.afDB.list('/cuadrillas/' + this.usuario + '/personal/');
        return this.afDB.list('/cuadrillas/' + this.usuario + '/personal/',{query:{orderByChild: 'Activo',equalTo : true }});
        
      }
     
      public getVariedades(){
        return this.afDB.list('/variedades/',{query:{orderByChild: 'Nombre'}});
      }  

      public getUsuario(){
        let strUsuario : string;
        let usuario : number;
        
        strUsuario = this.auth.getUser();
        strUsuario = strUsuario.substring(0,3);
        usuario = parseInt(strUsuario);
        
        return usuario;
      }

      //Devuelve el idParte siguiente.
      getIdParte(){
        let partesArray = [];
        
        this.getPartes()
        .subscribe(partes => {
            partesArray = partes;
        });

        if (partesArray.length <= 0){
          return 23000000 + this.usuario * 1000;
        }
        else{
          return partesArray[partesArray.length - 1].id;
        }
      }
}


// WEBPACK FOOTER //
// ./src/services/partes.services.ts